import React from 'react';
import { CheckCircleIcon, ClockIcon } from 'lucide-react';
import { StatusHistory } from '../types';
import { StatusBadge } from './StatusBadge';
export interface OrderTimelineProps {
  history: StatusHistory[];
}
export function OrderTimeline({
  history
}: OrderTimelineProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };
  const sortedHistory = [...history].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
  return <div className="space-y-6" data-id="element-325">
      {sortedHistory.map((item, index) => <div key={item.id} className="relative" data-id="element-326">
          {index !== sortedHistory.length - 1 && <div className="absolute left-4 top-10 bottom-0 w-0.5 bg-slate-200" data-id="element-327" />}

          <div className="flex items-start space-x-4" data-id="element-328">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center" data-id="element-329">
              {index === 0 ? <CheckCircleIcon className="w-5 h-5 text-green-600" data-id="element-330" /> : <ClockIcon className="w-5 h-5 text-slate-400" data-id="element-331" />}
            </div>

            <div className="flex-1 min-w-0" data-id="element-332">
              <div className="flex items-center space-x-3 mb-1" data-id="element-333">
                <StatusBadge status={item.status} data-id="element-334" />
                <span className="text-sm text-slate-500" data-id="element-335">
                  {formatDate(item.updatedAt)}
                </span>
              </div>

              <p className="text-sm text-slate-700 mb-1" data-id="element-336">
                Updated by <span className="font-medium" data-id="element-337">{item.updatedBy}</span>
              </p>

              {item.notes && <p className="text-sm text-slate-600 bg-slate-50 rounded p-2 mt-2" data-id="element-338">
                  {item.notes}
                </p>}
            </div>
          </div>
        </div>)}
    </div>;
}